<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 pt-2 :class="{'ml-5': $vuetify.breakpoint.mdAndUp}">
        <v-btn
          color="primary"
          outline
          :block="$vuetify.breakpoint.smAndDown"
          class="ml-0"
          @click="open()"
        >
          <v-icon left color="primary">android</v-icon>
          {{ bots.length }} / {{ $tc('chatbots', $store.state._User.bots.length, { count: $store.state._User.bots.length }) }}
        </v-btn>
      </v-flex>
    </v-layout>
    <!-- Sélectionner les bots -->
    <v-dialog v-model="dialog" scrollable persistent max-width="350px">
      <v-card>
        <v-card-title class="primary white--text">
          <div class="headline">{{ $t('select') | cap }} {{ $tc('chatbots', 2, { count: ' ' }) }}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">
          <v-data-table
            :headers="header"
            :items="$store.state._User.bots"
            v-model="botsTmp"
            item-key="USR_ID"
            select-all="primary"
            class="elevation-1"
            hide-actions
            :total-items="$store.state._User.bots.length"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    color="primary"
                    hide-details
                    @click.native="toggleAll"
                    :input-value="props.all || (botsTmp.length == bots.length)"
                    :indeterminate="props.indeterminate"
                  ></v-checkbox>
                </th>
                <th class="text-xs-left">
                  <span class="subheading">{{ header[0].text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-if="withoutMe && (props.item.USR_ID == $store.state._User.id)"
                  color="primary"
                  hide-details
                  value
                  :input-value="iAmChoosen"
                ></v-checkbox>
                <v-checkbox
                  v-else
                  color="primary"
                  hide-details
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                <wz-avatar
                  :username="props.item.USR_FIRST_NAME  + ' ' + props.item.USR_LAST_NAME"
                  :src="`${domaine}/media/user/small/${props.item.USR_ID}_avatar.jpg`"
                  size="35px"
                ></wz-avatar>
                <span class="ml-2">
                  {{ props.item.USR_FIRST_NAME + ' ' + props.item.USR_LAST_NAME }}
                </span>
                <span v-if="(props.item.USR_ID == $store.state._User.id)">
                  ({{ $t('me') }})
                </span>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel()">{{ $t('cancel') }}</v-btn>
          <v-btn :disabled="botsTmp.length < min" color="primary" @click="submit()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
export default {
  props: {
    /**
     * Bots sélectionnés
     */
    bots: {
      type: Array,
      required: true
    },
    /**
     * Bots sélectionnables
     */
    botsInit: {
      type: Array,
      required: true
    },
    /**
     * Indique si l'utilisateur
     * ne doit pas apparaître dans
     * la liste des bots
     */
    withoutMe: {
      type: Boolean,
      default: false
    },
    /**
     * Indique le nombre d'bots
     * qui doivent être sélectionnés
     */
    min: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      domaine: DOMAINE,
      /**
       * bots sélectionnés dans le dialog
       * @type {Array}
       */
      botsTmp: null,
      /**
       * Indique si le dialog est ouvert
       * @type {Boolean}
       */
      dialog: false,
      /**
       * Indique si l'bot est choisi dans la liste
       * @type {Boolean}
       */
      iAmChoosen: false
    }
  },

  created () {
    this.botsTmp = this.bots
    this.iAmChoosen = !_.isNil(_.find(this.botsTmp, {'USR_ID': this.$store.state._User.id}))
  },

  computed: {
    header () {
      return this.botsTmp && !this.botsTmp.length
      ? [{text: _.upperFirst(this.$t('none')), align: 'left', sortable: false}]
      : [{text: _.upperFirst(this.$tc('all', 1)), align: 'left', sortable: false}]
    }
  },

  methods: {
    open () {
      this.botsTmp = this.bots
      this.dialog = true
    },
    submit () {
      this.$emit('update:bots', this.botsTmp)
      this.dialog = false
    },
    cancel () {
      this.dialog = false
    },
    toggleAll () {
      if (this.botsTmp.length) this.botsTmp = []
      else this.botsTmp = this.botsInit.slice()
    }
  },

  watch: {
    /**
     * Empêche de changer la valeur de l'bot
     * si le props 'withoutMe' est 'vrai'
     */
    botsTmp (newVal, oldVal) {
      if (this.withoutMe && oldVal) {
        // recherche si l'utilisateur est dans les bots cochés auparavant
        let meInOld = _.find(oldVal, {'USR_ID': this.$store.state._User.id})
        let meInNew = _.findIndex(newVal, {'USR_ID': this.$store.state._User.id})
        // si oui : doit se retrouver dans newVal
        // sinon : doit être supprimer de newVal
        if (meInOld) {
          if (meInNew === -1) {
            newVal.push(meInOld)
          }
        } else {
          if (meInNew !== -1) {
            newVal.splice(meInNew, 1)
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectBots.vue